export default __webpack_public_path__ + "static/media/logo_petronas.9ba65593.svg";